import {AfterViewInit, Directive, ElementRef, Inject, Input, OnChanges, PLATFORM_ID, SimpleChanges} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import type {SwiperOptions} from 'swiper/types';

interface SwiperContainerElement extends HTMLElement {
  initialize?: () => void;
  swiper?: { update: () => void; updateSlides: () => void };
}

@Directive({selector: 'swiper-container[sale4AllSwiper]', standalone: true})
export class SwiperElementDirective implements AfterViewInit, OnChanges {
  @Input('sale4AllSwiper') config: SwiperOptions = {};
  private initialized = false;

  constructor(
    private readonly host: ElementRef<SwiperContainerElement>,
    @Inject(PLATFORM_ID) private readonly platformId: object
  ) {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) this.initialize();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.initialized && changes['config']) {
      Object.assign(this.host.nativeElement, this.config);
      this.host.nativeElement.swiper?.update();
    }
  }

  private async initialize(): Promise<void> {
    const {register} = await import('swiper/element/bundle');
    register();
    await customElements.whenDefined('swiper-container');
    await new Promise<void>(resolve => requestAnimationFrame(() => requestAnimationFrame(() => resolve())));
    Object.assign(this.host.nativeElement, this.config);
    this.host.nativeElement.initialize?.();
    await new Promise<void>(resolve => requestAnimationFrame(() => resolve()));
    this.host.nativeElement.swiper?.updateSlides();
    this.host.nativeElement.swiper?.update();
    this.initialized = true;
  }
}
